<template>
	<div v-if="getConvertedText || getEmptyBodyWithURL" :class="{ 'text-right': !message.Inbound }">
		<div class="rounded text-left message" v-bind:class="getColorStyle" >
			<div v-if="hasMediaUrl">
				<a v-if="isImage" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<img width="250" :src="message.mediaUrl"/>
				</a>
				<a v-if="isAudio" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<v-icon scale="2.5" name="music" />
				</a>
				<a v-if="isVideo" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<v-icon scale="2.5" name="video" />
				</a>
				<a v-if="isDocument" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<v-icon scale="2.5" name="file" />
				</a>
			</div>
			
			<span style="word-break: break-word; word-wrap: break-word" v-html="getConvertedText"></span>
			<div v-if="checkIfEmailData" class="d-flex align-items-center custom-email-button">
				<div class="email-icon">
					<v-icon name="envelope" scale="3"  :class="getClassName"/>
				</div>
				<b-button  variant="primary" @click="$emit('openEmailM', message,'withDetails')">{{checkIfEmailData}} </b-button>
			</div>
			<!-- <b-button v-if="checkIfEmailData" variant="primary" @click="$emit('openEmailM', message,'withDetails')">{{checkIfEmailData}} <b-badge variant="light">1</b-badge></b-button> -->
		</div>
		<div class="px-2">
			<div v-if="message.Scheduled">
				<span style="font-size:14px">Scheduled for {{$parsePlainDate(message.SendOn)}} at {{$parsePlainTime(message.SendOn)}} <span style="text-decoration:underline;cursor: pointer" @click="cancelMessage(message)">Cancel</span></span>
			</div>
			<div v-else>
				<v-icon v-if="message.Status == 'Sending'" name="sync" spin />
					<div v-else-if="message.Status == 'Failed'" class="text-danger">
						<b-button class="p-0 error" variant="outline" @click="$emit('resend')" pill>Resend</b-button>
						|
						<b-button class="p-0 error" variant="outline" @click="$emit('delete')" pill>Delete</b-button>
					</div>
				<span v-else>
					<div v-if="message.Inbound">
						<span @click="messageSendBy(message.FromNumber)">
							{{time}}
							<span class="sendBy">{{message.FromName}}</span>
						</span>  
					</div>
					<div v-else>
						<span @click="messageSendBy(message.FromNumber)">
							<span class="sendBy">{{message.FromName}}</span>
							{{time}}
						</span> 
					</div>	 
				</span>
			</div>
		</div>

		<!-- <b-modal id="EmailModal" centered  size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				Send Email
			</template>
			<EmailModal :emailData="emailData" />
		</b-modal> -->
	</div>
</template>

<script>
	import { getMediaDetails } from 'src/db'
	import axios from "axios";
	import { mapState } from 'vuex'
	// import EmailModal from "./EmailModal.vue";
	export default {
		name: 'groupMessage',
		props: {
			message: {
				Body: String,
				Date: String,
				Status: String,
				Inbound: Boolean,
				loader:Boolean,
			}
		},
		computed: {
			getClassName() {
				if (this.message.Inbound) {
					return 'text-blue'
				}else {
					return 'text-white'
				}
			},
			hasMediaUrl() {
				let value =  false;
				value =  (Object.keys(this.message).includes('mediaUrl') && this.message.mediaUrl);
				if(value && this.message.Inbound) {
					this.getInBoundSMSType();
				}
				return value
			},
			isImage() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.imageFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else {
					// value = this.message.mediaUrl.includes('jpg','jpeg','png','gif','bmp');
					this.imageFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.audioFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else {
					// value = this.message.mediaUrl.includes('basic','L24','mp4');
					this.audioFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.videoFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else {
					// value = this.message.mediaUrl.includes('webm','mpeg','3gpp');
					this.videoFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.documentFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else{
					// value = this.message.mediaUrl.includes('pdf','vcard','csv');
					this.documentFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			time() {
				if (this.message.Date) {
					if (this.isNotToday(this.message.Date)) {
						return this.$parsePlainDate(this.message.Date) + ' ' + this.$parsePlainTime(this.message.Date);
					}else {
						return this.$parsePlainTime(this.message.Date);
					}
					// return this.$parseDate(this.message.Date);
				}
				return null
			},
			getConvertedText() {
				if (this.message.hasOwnProperty('Subject')) {
					// return '<b-button variant="primary">'+this.message.Subject+ '<b-badge variant="light">4</b-badge></b-button>'
					// return '<a href=""'+'target="_blank"'+'>' + this.message.Subject + '</a>';
					// return '<b-button variant="'+'primary'+'" >'+this.message.Subject+'</b-button>'
					
					return '<v-icon name="envelope" scale="3" class="text-blue" />'
				}else {
					var urlRegex = /(https?:\/\/[^\s]+)/g;
					if (this.message.SmsStatus == 'cancelled') {
						return
					}else {
						return this.message.Body.replace(urlRegex, function(url) {
							return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
						});
					}
				}
			},
			checkIfEmailData() {
				let sub = '';
				if (this.message.hasOwnProperty('Subject')) {
					sub =  this.message.Subject;
				}
				return sub
			},
			getEmptyBodyWithURL() {
				let val = false;
				if (this.message.mediaUrl) {
					if (this.message.hasOwnProperty('Scheduled') && !this.message.Scheduled) {
						val = false;
					}else {
						val = true;
					}
				}
				return val
			},
			getColorStyle() {
				// message.Status == 'Failed' ? 'bg-danger' : message.Inbound ? 'bg-light' : 'blue text-white'
				return this.message.Status == 'Failed' ? 'bg-danger' : this.message.Inbound ? 'bg-light' : this.message.Scheduled ? 'green text-white' : 'blue text-white'
				
			},
			...mapState('globals', ['activegroupConvo', 'activegroupProsp']),
			...mapState('firebase', ['prospects', 'groupconvos', 'user'])
			
		},
		components: {
			// EmailModal,
        },
		created() {
			//eslint-disable-next-line
			// console.log('groupMessagePage', this.message);
		},
		methods:{
			messageSendBy(senderby) {
				let prospDetails = this.prospects.find(prosp => prosp.Number == senderby);
				setTimeout(() => {
					this.$router.push('/home/Conversations');
					this.$store.commit('globals/SET', { var: 'activeProsp', val: prospDetails.id });
					let convo = this.convos.find(convo => convo.ClientNumber == senderby);
					if (convo) {
						this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
						this.$store.dispatch('firebase/bindMessages', convo.id);
						this.$emit('groupopen', 'groupconvo');
					}
				}, 500);
			},
			getInBoundSMSType() {
				let data = this.message.mediaUrl.split('/');
				getMediaDetails({messageId:data[7],mediaId:data[9]})
				.then((res) => { this.getContentType(res)})
				.catch(err => alert(`Failure getting inbound sms URL: ${err}`));
			},
			getContentType(res) {
				const items =  JSON.parse(res.data);
				this.InboundMediaType = items.contentType;
			},
			cancelMessage(smsDetail) {
				if (confirm("Are you sure you want to cancel this scheduled message?")) {
					this.message.loader = true;
					this.$emit('cancelClick', true);
					const smsData = {
						pid:this.user.id,
						cid:this.activeProsp,
						SmsId:smsDetail.SmsId
					};
					axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/cancelSms", smsData)
					.then(response => {
							// eslint-disable-next-line
						console.log(response);
						this.message.loader = false;
						this.$emit('cancelClick', false);
						this.$store.dispatch('firebase/rebindConvosScheduledCount', {
							uid: this.user.Uid,
							id: this.user.id,
						})
					});
				}
			},
			isNotToday(milliseconds) {
				let date = new Date(parseInt(milliseconds));
				let now = new Date();
				if (date.getFullYear() === now.getFullYear() &&
					date.getMonth() === now.getMonth() &&
					date.getDate() === now.getDate()) {
					return false;
				}
				return true;
			},
			// openEmailModal() {
			// 	let emailDetailsObject = {
			// 			user:this.user,
			// 			// prospect:this.prospect
			// 			message:this.message,
			// 			type:'fromSingle'
			// 		}
			// 	this.emailData = emailDetailsObject;
			// 	this.$bvModal.show('EmailModal');
			// }
		},
		
		data() {
			return {
				emailData:{},
				InboundMediaType:'',
				imageFormatArray:['jpg','jpeg','png','gif','bmp','PNG','JPG','JPEG'],
				audioFormatArray:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArray:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264',],
				documentFormatArray:['pdf','vcard','csv','rtf','richtext','calendar','directory']

			}
		}
	}
</script>

<style scoped>
.sendBy{
	cursor: pointer;
	font-weight: 600;
    color: #5e5e5e!important;
    margin: 0px 8px;
	font-size: 15px;
}

button.error {
	color: inherit;
	font-size: .7em;
	box-shadow: none;
}
button.error:active {
	color: pink;
	text-decoration: underline;
}
.message {
	font-size: 1.1em;
	display: inline-block;
	max-width: 80%;
	padding: 8px 10px;
	white-space: pre-line;
	box-shadow: 1px 1px 1px lightgray;
}
.green {
	background-color:#385723;
}
.email-icon svg{
	width: 20px !important;height: auto !important;
}
.email-icon{
	margin-right: 10px;
}
.custom-email-button button{
	padding:0px 5px !important;
	font-size: 14px;
}
</style>